import { combineReducers } from "redux";
import reducer from "./reducer";
import apiReducer from "./apiReducer"


const reducers: any = combineReducers({
    appReducer: reducer,
    apiReducer: apiReducer
})

export default reducers

export type RootState = ReturnType<typeof reducers>